import moment from "moment";

const industryAndLabelToFilter = (industries, industryLabel) => {    
    // Derzeit nur für eine Branche, wird nirgends für mehrere Branchen verwendet     
    let bindIndustryLabel = (industryLabel && industryLabel !== '-') ? `BIND("${industryLabel}" AS ?labelName_)` : '';
    let bindIndustry = (industries[0].name && industries[0].name !== 'Alle') ? `BIND("${industries[0].name}" AS ?labelGroup_)` : '';

    return `
     ?publication at-kdvo-raw:cpvMain ?cpvMain_ .
      ?label2cpvId core:cpv ?cpvMain_ ;
                 core:idLabel ?label .      
      ${bindIndustry}
      ?label core:group ?labelGroup_ .
      ${bindIndustryLabel}
      ?label core:name  ?labelName_.      
    `;
  }

  // at-kdvo-raw:processStage is set for KD and eForms publications alike.
  const STAGE_VALUES = {
    Neu: 'new',
    Vorinfo: 'prePublication',
    Zuschlag: 'award',
  };

  // Accepts a single stage name ('Neu' | 'Vorinfo' | 'Zuschlag') or an array of them.
  export function filterVerfahrensStufe(verfahrensStufe) {
    const stages = Array.isArray(verfahrensStufe) ? verfahrensStufe : [verfahrensStufe];
    const values = stages.map((s) => STAGE_VALUES[s]).filter(Boolean);
    if (values.length === 0) return '';
    return `VALUES ?stageFilter_ { ${values.map((v) => `"${v}"`).join(' ')} }
            ?publication at-kdvo-raw:processStage ?stageFilter_ .`;
  }

export const getQuery = (props) => {
  // fix me "invalid date"
  // console.log('props.filter.kdqLastmodTo', props.filter.kdqLastmodTo);
  // console.log('props.filter.kdqLastmodTo', (props.filter.kdqLastmodTo));

    // let filterFrom = 'FILTER (?downloaded_ >= "' + new Date(Date.now() - 24*60*60*1000).toISOString() + '"^^xsd:dateTime)';
    console.log('props.filter publicationQueryBuilder', props.filter);
    let filterFrom = '';
    if(props.filter.downloadFrom && moment(props.filter.downloadFrom).isValid()) {            
        filterFrom = 'FILTER (?downloaded_ >= "' + new Date(props.filter.downloadFrom).toISOString() + '"^^xsd:dateTime)';      
    }
    
    let filterTo = '';
    if(props.filter.downloadTo && moment(props.filter.downloadTo).isValid()) {
        // Set time to end of day (23:59:59.999) on the downloadTo date
        let endOfDay = new Date(props.filter.downloadTo);
        endOfDay.setHours(23, 59, 59, 999);
        filterTo = 'FILTER (?downloaded_ <= "' + endOfDay.toISOString() + '"^^xsd:dateTime)';
    }
    
    let filterIndustryAndLabel1 = ((props.filter.industryLabel  && props.filter.industryLabel !== '-') || (props.filter.industries && props.filter.industries[0].name !== 'Alle')) ? ' ?labelName_  ?labelGroup_' : '';
    let filterIndustryAndLabel2 = ((props.filter.industryLabel  && props.filter.industryLabel !== '-') || (props.filter.industries && props.filter.industries[0].name !== 'Alle')) ? industryAndLabelToFilter(props.filter.industries, props.filter.industryLabel) : '';
    

    const verfahrensStufeFilter = props.filter.verfahrensStufe;
    const hasVerfahrensStufe = Array.isArray(verfahrensStufeFilter)
      ? verfahrensStufeFilter.length > 0
      : (verfahrensStufeFilter && verfahrensStufeFilter !== '-');
    let filterProcessStage = hasVerfahrensStufe ? filterVerfahrensStufe(verfahrensStufeFilter) : '';
    
    const buildWordQuery = (variable, value) => {
      if(!value) return '';
      const term = value.toLowerCase();
      const hasWildcard = term.includes('*');
      if (hasWildcard) {
        // Wildcard search: use cts:word-query with wildcarded option
        return `FILTER cts:contains(${variable}, cts:word-query("${term}", "wildcarded"))`;
      } else {
        // Exact match: use regex with anchors for whole value matching (case-insensitive)
        const escaped = term.replace(/[-/\\^$+?.()|[\]{}]/g, '\\$&');
        return `FILTER regex(${variable}, "^${escaped}$", "i")`;
      }
    };

    const buildRegexFromWildcard = (value) => {
      if(!value) return '';
      const hasWildcard = value.includes('*');
      const escaped = value.replace(/[-/\\^$+?.()|[\]{}]/g, '\\$&').replace(/\*/g, '.*');
      // If no wildcard, match exact value with anchors
      return hasWildcard ? escaped : `^${escaped}$`;
    };

    // Multiple CPV codes/patterns can be given, separated by space or comma —
    // they are combined with OR (CPV codes contain neither character)
    const buildCpvRegex = (value) => {
      return value.trim().split(/[\s,]+/).filter(Boolean)
        .map(part => `(${buildRegexFromWildcard(part)})`)
        .join('|');
    };

    // CPV searches match the main and all additional CPV codes of a publication
    let filterCPV = '';
    if(props.filter.cpv && props.filter.cpv !== '') {
      filterCPV = `
      ?publication at-kdvo-raw:cpvMain|at-kdvo-raw:cpvAdditional ?cpvSearch_ .
      FILTER regex(STR(?cpvSearch_), "${buildCpvRegex(props.filter.cpv)}", "i")
      `
    }

    let filterCPVDescription = '';
    if(props.filter.cpvDescription && props.filter.cpvDescription !== '') {
      filterCPVDescription = `
      ?publication at-kdvo-raw:cpvMain|at-kdvo-raw:cpvAdditional ?cpvDescriptionCodeSearch_ .
      ?cpvEntity core:code ?cpvDescriptionCodeSearch_ .
      ?cpvEntity core:description ?cpvDescription_ .
      ${buildWordQuery('?cpvDescription_', props.filter.cpvDescription)}
      `;
    }
    // NUTS filter on the place of performance (at-kdvo-raw:nutsCode). Same
    // syntax as CPV: wildcards with *, several patterns separated by space or
    // comma are OR-joined. Publications carry codes at any level (AT, AT13,
    // AT130), so "AT13*" catches both the Bundesland and its NUTS-3 regions.
    let filterNuts = '';
    if(props.filter.nuts && props.filter.nuts !== '') {
      filterNuts = `
      ?publication at-kdvo-raw:nutsCode ?nutsSearch_ .
      FILTER regex(STR(?nutsSearch_), "${buildCpvRegex(props.filter.nuts)}", "i")
      `
    }

    // Combined title or description search with OR/AND clause
    let filterTitleOrDescription = '';
    if (props.filter.titleOrDescription && props.filter.titleOrDescription !== '') {
      const searchMode = props.filter.titleOrDescriptionMode || 'OR';
      const words = props.filter.titleOrDescription.trim().split(/\s+/);

      const wordConditions = words.map(word => {
        const term = word.toLowerCase().replace(/"/g, '');
        if (!term) return null;
        const hasWildcard = term.includes('*');

        if (hasWildcard) {
          return `cts:contains(?title_, cts:word-query("${term}", "wildcarded")) ||
        cts:contains(?shortDescSearch_, cts:word-query("${term}", "wildcarded"))`;
        } else {
          const escaped = term.replace(/[-/\\^$+?.()|[\]{}]/g, '\\$&');
          return `regex(?title_, "${escaped}", "i") ||
        regex(?shortDescSearch_, "${escaped}", "i")`;
        }
      });

      const validConditions = wordConditions.filter(Boolean);
      if (validConditions.length === 0) return;

      let filterCondition;
      if (validConditions.length === 1) {
        filterCondition = validConditions[0];
      } else if (searchMode === 'AND') {
        // AND: every word must appear in title or description
        filterCondition = validConditions.map(c => `(${c})`).join(' &&\n        ');
      } else {
        // OR: any word may appear in title or description
        filterCondition = validConditions.join(' ||\n        ');
      }

      filterTitleOrDescription = `
      OPTIONAL { ?publication at-kdvo-raw:shortDescription ?shortDescSearchRaw_. }
      BIND(COALESCE(?shortDescSearchRaw_, "") AS ?shortDescSearch_)
      FILTER (
        ${filterCondition}
      )
      `;
    }

    let filterActivityType = '';
    if(props.filter.activityType && props.filter.activityType !== '-') {
      filterActivityType = `
      ?resolveResult kg:contractingBody ?contractingBody .
      ?contractingBody core:activityType ?activityType_ .
      FILTER (?activityType_ = "${props.filter.activityType}")
      `;
    }

    let filterContractingBodyText = '';
    if(props.filter.contractingBodyText && props.filter.contractingBodyText !== '') {
      const contractingBodyText = props.filter.contractingBodyText.toLowerCase();
      const hasWildcard = contractingBodyText.includes('*');

      let filterCondition;
      if (hasWildcard) {
        // Wildcard search: use cts:word-query with wildcarded option
        filterCondition = `
        cts:contains(?contractingBodyNameSearch_, cts:word-query("${contractingBodyText}", "wildcarded")) ||
        cts:contains(?contractingBodyAliasSearch_, cts:word-query("${contractingBodyText}", "wildcarded")) ||
        cts:contains(?contractingBodyOfficialNameSearch_, cts:word-query("${contractingBodyText}", "wildcarded"))
        `;
      } else {
        // Exact match: use regex with anchors for whole value matching (case-insensitive)
        const escaped = contractingBodyText.replace(/[-/\\^$+?.()|[\]{}]/g, '\\$&');
        filterCondition = `
        regex(?contractingBodyNameSearch_, "^${escaped}$", "i") ||
        regex(?contractingBodyAliasSearch_, "^${escaped}$", "i") ||
        regex(?contractingBodyOfficialNameSearch_, "^${escaped}$", "i")
        `;
      }

      filterContractingBodyText = `
      OPTIONAL {
        ?resolveResult kg:contractingBody ?contractingBodySearch .
        ?contractingBodySearch core:name ?contractingBodyNameSearch .
        OPTIONAL { ?contractingBodySearch core:alias ?contractingBodyAliasSearch. }
      }
      OPTIONAL {
        ?publication at-kdvo-raw:contractingBody ?contractingBodyNodeSearch.
        ?contractingBodyNodeSearch at-kdvo-raw:officialName ?contractingBodyOfficialNameSearch.
      }
      BIND(COALESCE(?contractingBodyNameSearch, "") AS ?contractingBodyNameSearch_)
      BIND(COALESCE(?contractingBodyAliasSearch, "") AS ?contractingBodyAliasSearch_)
      BIND(COALESCE(?contractingBodyOfficialNameSearch, "") AS ?contractingBodyOfficialNameSearch_)
      FILTER (
        ${filterCondition}
      )
      `;
    }
    
    let filterMentionedInTextDocument1 = '';
    let filterMentionedInTextDocument2 = '';

    if(props.filter?.mentionedOrgId) {
      filterMentionedInTextDocument1 = `
      OPTIONAL {
        {
          ?procedureResolveResultMention kg:publication ?publication; kg:procedureId ?procedureIdMention.
          ?download kg:procedureId ?procedureIdMention.
        } UNION {
          ?download kg:forPublication ?publication.
          FILTER NOT EXISTS { ?download kg:procedureId ?anyProcedureIdMention }
        }
        ?downloadedFile kg:downloadId ?download.
        ?downloadedFile kg:textDocument ?textDocument.
        ?textDocument kg:mentionsOrganization <${props.filter?.mentionedOrgId}>.        
      }
      OPTIONAL {
        ?resolveResult kg:additionalContact ?additionalContacts.
        FILTER(?additionalContacts = <${props.filter?.mentionedOrgId}>)
      }
      FILTER (BOUND(?textDocument) || BOUND(?additionalContacts))
      `
      filterMentionedInTextDocument2 = `        
        FILTER (?contractingBody != <${props.filter?.mentionedOrgId}>)
      `;
    }
    
    // Handle multiple contracting bodies
    let bindContractingBodies = '';
    if (props.filter.contractingBodies && props.filter.contractingBodies.length > 0) {
      bindContractingBodies = `
      VALUES ?contractingBodyFilter {
        ${props.filter.contractingBodies.map(cb => `<${cb}>`).join('\n        ')}
      }
      ?resolveResult kg:contractingBody ?contractingBodyFilter .
      `;
    }

    // Handle multiple contractors
    let bindContractors = '';
    if (props.filter.contractors && props.filter.contractors.length > 0) {
      bindContractors = `
      VALUES ?contractorFilter {
        ${props.filter.contractors.map(contractor => `<${contractor}>`).join('\n        ')}
      }
      ?resolveResult kg:contractor ?contractorFilter .
      `;
    }

    // ------------------------------------------------------------------------------------------------
    // 18.4.2025 Ab hier Altbestand, noch nicht verifiziert im Zuge der Optimierung

    // let filterLastmodFrom = '';
    // if(props.filter.kdqLastmodFrom && props.filter.kdqLastmodFrom !== -3600000 && moment(props.filter.kdqLastmodFrom).isValid()) {      
    //   filterLastmodFrom = 'FILTER (?kdqLastmod >= "' + new Date(props.filter.kdqLastmodFrom).toISOString() + '"^^xsd:dateTime)';      
    // }
    
    // let filterLastmodTo = '';
    // if(props.filter.kdqLastmodTo && props.filter.kdqLastmodTo !== -3600000 && moment(props.filter.kdqLastmodTo).isValid()) {
    //   var nextDay = new Date();
    //    nextDay.setTime(props.filter.kdqLastmodTo.getTime() +  (1 * 24 * 60 * 60 * 1000));
    //    filterLastmodTo = 'FILTER (?kdqLastmod <= "' + nextDay.toISOString() + '"^^xsd:dateTime)';
    // }
    
    // let filterContractorName = props.filter.contractorName ? `FILTER (regex(str(?contractorName), "${props.filter.contractorName}" ) || regex(str(?contractorPublicationName), "${props.filter.contractorName}" ))` : '';
    // let filterContractingBodyName = props.filter.contractingBodyName ? `FILTER (regex(str(?contractingBodyName), "${props.filter.contractingBodyName}" ) || regex(str(?contractingBodyNamePublication), "${props.filter.contractingBodyName}" ))` : '';      
    // let filterText = props.filter.text ? `FILTER (regex(str(?shortDescription), "${props.filter.text}" ) || regex(str(?title), "${props.filter.text}" ))` : '';
    
    // let filterOrganisation = '';
    /* if (props.filter?.orgId && props.filter.orgId !== '' && !props.filter?.isAdditionalContact && !props.filter?.isMentionedInTextDocument) {
      filterOrganisation = `FILTER (?contractor = <${props.filter?.orgId}> || ?contractingBody = <${props.filter?.orgId}>)`;
    } */

     let filterIsAdditionalContact = '';
     if(props.filter?.isAdditionalContact) {
       filterIsAdditionalContact = `     
        ?resolveResult kg:additionalContact <${props.filter?.orgId}>.            
       `;
     }
// ------------------------------------------------------------------------------------------------


    let queryString = `
    PREFIX core: <https://deepick.eu/schema/sql-import/v1/pred#>
    PREFIX kg: <https://deepick.eu/schema/kg/v1/pred#>
    PREFIX at-kdvo-raw: <https://deepick.eu/schema/at-kdvo-raw/v1/pred#>
    PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>
    PREFIX xsd: <http://www.w3.org/2001/XMLSchema#>
    PREFIX cts: <http://marklogic.com/cts#>

    SELECT
      ?publication
      (SAMPLE(?downloaded_) AS ?downloaded)
      (SAMPLE(?title_) AS ?title)
      (SAMPLE(?kdqLastmod_) AS ?kdqLastmod)
      (SAMPLE(?contractor) AS ?contractor)
      (SAMPLE(?contractorName_) AS ?contractorName)
      (SAMPLE(?contractorNamePub_) AS ?contractorPublicationName)
      (SAMPLE(?shortDescription_) AS ?shortDescription)
      (SAMPLE(?totalValue_) AS ?totalValue)
      (SAMPLE(?contractingBodyNamePub_) AS ?contractingBodyNamePublication)
      (SAMPLE(?contractingBodyName_) AS ?contractingBodyName)
      (SAMPLE(?contractingBody) AS ?contractingBody)
      (SAMPLE(?cpvMain_) AS ?cpvMain)
      (SAMPLE(?labelName_) AS ?labelName)
      (SAMPLE(?labelGroup_) AS ?labelGroup)
      (SAMPLE(?processStage_) AS ?processStage)
      (COUNT(DISTINCT ?contractor) AS ?numberOfContractor) 
      (COUNT(DISTINCT ?contractingBody) AS ?numberOfContractingBody) 
      (COUNT(?file) AS ?numberOfFiles)

      WHERE
              {
                {
          ## --------------------------------------------------------
          ## 1) Subquery: Filter & limit the relevant publications
          ## --------------------------------------------------------
          SELECT DISTINCT ?publication ?resolveResult
                          ?downloaded_ ?title_ ?kdqLastmod_ ${filterIndustryAndLabel1}
          WHERE {
            ${(filterProcessStage)}
            ?publication rdf:type <https://deepick.eu/schema/at-kdvo-raw/v1/type#publication> ;
                        at-kdvo-raw:downloaded ?downloaded_ ;
                        at-kdvo-raw:title      ?title_ ;
                        at-kdvo-raw:kdqLastmod ?kdqLastmod_ . 
            ?resolveResult kg:publication ?publication.      
            ${filterIsAdditionalContact}
            ${filterIndustryAndLabel2}
            ${filterCPV}
            ${filterCPVDescription}
            ${filterNuts}
            ${filterActivityType}
            ${filterContractingBodyText}
            
            ${filterMentionedInTextDocument1}

            ${filterFrom}
            ${filterTo}
          
            ${bindContractingBodies}
            ${bindContractors}

            ${filterTitleOrDescription}
          }
          GROUP BY ?publication
          ORDER BY DESC(?downloaded_)
          LIMIT ${props.records}
        }

  ## --------------------------------------------------------
  ## OPTIONAL ENRICHMENT BLOCKS
  ## --------------------------------------------------------

  OPTIONAL {
    ?resolveResult kg:contractor ?contractor .
    ?contractor core:name ?contractorName_ .
  }

  OPTIONAL {
    ?publication at-kdvo-raw:shortDescription ?shortDescription_ .
  }

  OPTIONAL {
    ?publication at-kdvo-raw:processStage ?processStage_ .
  }

  OPTIONAL {
    ?publication at-kdvo-raw:totalValue ?totalValue_ .
  }

  OPTIONAL {
    ?publication at-kdvo-raw:contractor ?contractorPublication .
    ?contractorPublication at-kdvo-raw:officialName ?contractorNamePub_ .
  }

  OPTIONAL {
    ?resolveResult kg:contractingBody ?contractingBody .
    ?contractingBody core:name ?contractingBodyName_ .
    ${filterMentionedInTextDocument2}
  }

  OPTIONAL {
    ?publication at-kdvo-raw:contractingBody ?cbPub .
    ?cbPub at-kdvo-raw:officialName ?contractingBodyNamePub_ .
  }

  OPTIONAL {
            {
              ?procedureResolveResultFiles kg:publication ?publication; kg:procedureId ?procedureIdFiles.
              ?downloadId kg:procedureId ?procedureIdFiles.
            } UNION {
              ?downloadId kg:forPublication ?publication.
              FILTER NOT EXISTS { ?downloadId kg:procedureId ?anyProcedureIdFiles }
            }
            ?file kg:downloadId ?downloadId.
          }
  
  OPTIONAL {
    ?publication at-kdvo-raw:cpvMain ?cpvMain_ .
    ?label2cpvId core:cpv ?cpvMain_ ;
                 core:idLabel ?labelId .
    ?labelId core:name  ?labelName_ ;
             core:group ?labelGroup_ .             
  }    
}
GROUP BY ?publication    
ORDER BY DESC(?downloaded_)
`
// console.log('queryString of query builder', queryString);
// console.log('getQuery props', props);
return queryString
}
